///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { formatDistanceStrict } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

import getLeastProgressedMode from "./getLeastProgressedMode";

const getLastStatusChangeDate = (bid, user, timeZone) => {
  const mode = getLeastProgressedMode(bid.modes, user);
  const zonedLastStatusChangeDate = utcToZonedTime(
    mode.lastStatusChangeDateUTC + "Z",
    timeZone
  );
  const formattedLastStatusChangeTime = formatDistanceStrict(
    zonedLastStatusChangeDate,
    new Date()
  );

  return formattedLastStatusChangeTime;
};

export default getLastStatusChangeDate;
